import React from "react";
//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";

import FacebookProvider, { Page } from "react-facebook";

import styles from "./Sidebar.module.css";

class Sidebar extends React.Component {
  render() {
    return (
      <div className={styles.sidebarContainer}>
        {/* <div>
          <h2>Koledar dogodkov:</h2>
          <div className={styles.datePickerContainer}>
            <DatePicker inline />
          </div>
        </div> */}
        <FacebookProvider appId="1700062240278243">
          <Page
            href="https://www.facebook.com/bit.badminton/"
            tabs="timeline"
            hideCover={true}
            smallHeader={true}
            height="1000px"
            styles={{ width: "250px" }}
          />
        </FacebookProvider>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js